import { StationsTableHeaderProps } from './StationsTableHeader.types';

/**
 * Renders table header for stations pricing table with fuel type columns
 *
 * @param props - The component props
 * @returns JSX element containing the stations table header
 */
export const StationsTableHeader = ({ fuelTypes, isMobile, tableClass, scrollRef, hideSales = false }: StationsTableHeaderProps) => {
  return (
    <div className="stations-table-header-wrapper" ref={scrollRef}>
      <table className={`${tableClass} ${isMobile ? 'mobile-table' : ''}`}>
        <colgroup>
          <col className="stations-col-brand" />
          <col className="stations-col-unicode" />
          <col className="stations-col-address" />
          <col className="stations-col-photo" />
          <col className="stations-col-date" />
          <col className="stations-col-influence" />
          <col className="stations-col-distance" />
          <col className="stations-col-location" />
          {!hideSales && <col className="stations-col-sales" />}
          {fuelTypes.map((fuel: string) => (
            <col key={fuel} className="stations-col-fuel" />
          ))}
        </colgroup>
        <thead>
          <tr className="header-row">
            <th className="header-cell" style={{ fontSize: '0.75rem', padding: '0.6rem 0.4rem' }}>
              Бренд
            </th>
            <th className="header-cell" style={{ fontSize: '0.75rem', padding: '0.6rem 0.4rem' }}>
              Юнікод
            </th>
            <th className="header-cell" style={{ fontSize: '0.75rem', padding: '0.6rem 0.4rem' }}>
              Адреса
            </th>
            <th className="header-cell" style={{ fontSize: '0.75rem', padding: '0.6rem 0.4rem' }}>
              Фото
            </th>
            <th className="header-cell" style={{ fontSize: '0.75rem', padding: '0.6rem 0.4rem' }}>
              Дата введ.
            </th>
            <th className="header-cell" style={{ fontSize: '0.75rem', padding: '0.6rem 0.4rem' }}>
              Вплив
            </th>
            <th className="header-cell" style={{ fontSize: '0.75rem', padding: '0.6rem 0.4rem' }}>
              Відст. км
            </th>
            <th className="header-cell" style={{ fontSize: '0.75rem', padding: '0.6rem 0.4rem' }}>
              Розміщ.
            </th>
            {!hideSales && (
              <th className="header-cell" style={{ fontSize: '0.75rem', padding: '0.6rem 0.4rem' }}>
                Реаліз. л/доб
              </th>
            )}
            {fuelTypes.map((fuel: string) => (
              <th key={fuel} className="header-cell fuel-header">
                {fuel}
              </th>
            ))}
          </tr>
        </thead>
      </table>
    </div>
  );
};
